import { Field } from 'formik'
import React from 'react'

const InputCode = ({ attr }) => {
    const generateUniqueID = () => {
        const timestamp = Date.now(); // Get the current timestamp in milliseconds
        const randomFactor = Math.floor(Math.random() * 1000); // Add a small random factor
        const uniqueID = timestamp * 1000 + randomFactor; // Combine timestamp with random factor
        return uniqueID;
    };

    return (
        <div className='flex-1 my-3 px-2'>
            <label htmlFor={attr.name}>{attr.placeholder}</label>
            <Field
                type={"text"}
                name={attr.name}
                placeholder={attr.placeholder}
                className={attr.className}
                defaultValue={generateUniqueID()}
            />
        </div>
    )
}

export default InputCode;